import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePlausible } from '../hooks/usePlausible';
import { PAGE_VIEW, PAGE_NOT_FOUND } from '../utils/analytics';
import { stripBasePath } from '../utils/basePath';

interface PlausibleScriptProps {
  domain?: string; // Now optional since we're using the context
}

/**
 * Component that tracks page views when route changes
 */
const PlausibleScript: React.FC<PlausibleScriptProps> = () => {
  const trackEvent = usePlausible();
  
  // Safe check for router context
  try {
    const location = useLocation();
    
    // Track page views when the route changes
    useEffect(() => {
      // Check if this is a 404 page by looking at the URL
      const url = new URL(window.location.href);
      const normalizedPath = stripBasePath(location.pathname);
      const isNotFound =
        url.searchParams.get('status') === '404' || normalizedPath === '/404';
      
      if (isNotFound) {
        trackEvent(PAGE_NOT_FOUND, {
          props: {
            path: normalizedPath
          }
        });
      } else {
        // Track normal page view
        trackEvent(PAGE_VIEW);
      }
    }, [location, trackEvent]);
  } catch (error) {
    // Router context not available, do nothing
    console.debug('Router context not available for PlausibleScript');
  }

  return null;
};


export default PlausibleScript; 
